import { PiwikProInitializer } from "@piwikpro/ngx-piwik-pro";
import { environment } from "src/environments/environment";
import { inject } from "@angular/core";
import { HttpBackend, HttpClient } from "@angular/common/http";
import { from, lastValueFrom, of, switchMap } from "rxjs";

export function piwikInitializerFactory(document: Document, platformId: string): () => Promise<void> {
  const httpBackend = inject(HttpBackend); // bypasses interceptors
  const http = new HttpClient(httpBackend); // manual creating new instance of HttpClient to using HttpClient without interceptor. Ref https://stackoverflow.com/questions/46469349/how-to-make-an-angular-module-to-ignore-http-interceptor-added-in-a-core-module

  let loadedEnv = {
    env: "developmet",
    path: `./assets/config/development.json`,
  };

  const environments = ["staging", "production"];
  for (const env of environments) {
    if (environment[env]) {
      loadedEnv.env = env;
      loadedEnv.path = `./assets/config/${env}.json`;
    }
  }
  console.log(loadedEnv.env);
  return () => {
    return lastValueFrom(
      http.get(loadedEnv.path).pipe(
        switchMap((config: any) => {
          const initPiwik = PiwikProInitializer(
            {
              containerId: "8f991b4d-5f9d-4fe9-bf02-4da8ee2eccd8",
              containerURL: "https://nilacandi.containers.piwik.pro",
            },
            document,
            platformId
          );
          return config.enablePiwikPro ? from(initPiwik()) : of(undefined);
        })
      )
    );
  };
}
